import { render, staticRenderFns } from "./SpecialSchools.vue?vue&type=template&id=f78a1a94"
import script from "./SpecialSchools.vue?vue&type=script&lang=js"
export * from "./SpecialSchools.vue?vue&type=script&lang=js"
import style0 from "./SpecialSchools.vue?vue&type=style&index=0&id=f78a1a94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports